
/*
'user.logged'事件在完成登录时触发，以便某些需要登录的页面可以监听并做处理

*/


{
    angular.module('utilsModule')
        .factory('utils.currentUser', currentUser);
    currentUser.$inject = ['utils.constant','request.login','$q','$rootScope'];
    function currentUser(constant,loginRequest,$q,$rootScope) {
        let collect={
            'info':null,
            'getUserInfo':getUserInfo,
            'logout':logout,
            'areaid':null,
            'areaname':null
        }
        
        function getUserInfo(){
            if(collect.info){
                return $q.when(collect.info);
            }

            let def=$q.defer();
            loginRequest.getUserId().then(function(resData){
                // console.log(resData);
                if(resData.result==1){
                    loginRequest.getUserInfoById(resData.loginuserid).then(function(resData){
                        // console.log(resData);
                        collect.info=resData.userInfo;
                        if(resData.result==1){
                           // console.log('登陆者信息：',resData.userInfo);
                            $rootScope.$broadcast('user.logged',resData.userInfo);
                            def.resolve(resData.userInfo);
                        }else{
                            def.reject('无法获取用户信息');
                        }
                        // def.resolve(resData);
                    },function(resData){
                        def.reject('无法获取用户信息');

                    });
                }else{
                    def.reject('未登录');
                }
                
            },function(resData){
                def.reject('未登录');
                
            });
            return def.promise;
        }

        function logout(){
            collect.info=null;
            loginRequest.logout();
        }

        return collect;
    }

}